module.exports = __webpack_public_path__ + "static/media/SummaryCh3&4_A01378565.fcd355df.pdf";